module.exports = __webpack_public_path__ + "img/care_system.b9a2f05d.jpg";